import React, {useState, useEffect, useCallback} from 'react';

//const logoutTime = (1 * 60 * 60 * 1000); // 1 hour * 60 minutes * 60 seconds * 1000 milliseconds
const logoutTime = (60 * 60 * 1000); // 1 hour * 60 minutes * 60 seconds * 1000 milliseconds
const priorNotificationTime = (5 * 60 * 1000); // 5 minutes * 60 seconds * 1000 milliseconds
let logoutTimer;
let notificationTimer;

const AuthContext = React.createContext({ // Could be a string but in this case, it's an object
	token: '',
	isLoggedIn: false,
	trustedBrowser: false,
	timeoutNotification: false,
	login: () => {}, // Just doing this here for IDE help
	logout: () => {}, // Just doing this here for IDE help
	trustBrowser: () => {}, // Just doing this here for IDE help
	updateExpiration: () => {} // Just doing this here for IDE help
});

const calculateRemainingTime = (expiration) => {
// console.log('calculateRemainingTime: expiration: ' + expiration);
	const currentTime = new Date().getTime(); // current time stamp in milliseconds
	const adjExpiration = new Date(expiration).getTime();
	const remainingTime = adjExpiration - currentTime;
// console.log('calculateRemainingTime: ' + remainingTime);
	return remainingTime;
}

const retrieveStoredToken = () => {
	const storedToken = localStorage.getItem('mlannex-token');
	const storedExpirationDate = localStorage.getItem('mlannex-expiration');

	// const storedUserData = JSON.parse(localStorage.getItem('userData'));
	// if (storedUserData && storedUserData.token) {
	// }

	const remainingTime = calculateRemainingTime(storedExpirationDate);
// console.log('retrieveStoredToken: remainingTime: ' + remainingTime);
	const notificationTime = remainingTime - priorNotificationTime;

	// if (remainingTime <= 60000)  {
	if (remainingTime <= 0)  {
		localStorage.removeItem('mlannex-token');
		localStorage.removeItem('mlannex-expiration');
		return null;
	}

	return {
		token: storedToken,
		duration: remainingTime,
		notification: notificationTime
	};
}

export const AuthContextProvider = (props) => {
	const tokenData = retrieveStoredToken();
	let initToken;
	if (tokenData) {
		initToken = tokenData.token;
	}
	const [token, setToken] = useState(initToken);
	const [trustedBrowser, setTrustedBrowser] = useState(false);
	const [timeoutNotification, settimeoutNotification] = useState(false);

	const userIsLoggedIn = !!token; // !! converts value to boolean. If empty, false; not empty true.

	const logoutHandler = () => {
		setToken(null);
		localStorage.removeItem('mlannex-token');
		localStorage.removeItem('mlannex-expiration');

		settimeoutNotification(false);

		if (logoutTimer) {
			clearTimeout(logoutTimer);
			clearTimeout(notificationTimer);
		}

		let rn = Math.floor(Math.random() * 1000000) + 1;
		window.location.href = "/?rn=" + rn.toString();
	}

	const notificationHandler = useCallback(() => {
// console.log('auth: notificationHandler: settimeoutNotification: true');
		settimeoutNotification(true);

		clearTimeout(notificationTimer);
// console.log('auth: notificationHandler END');
	}, []);

	const loginHandler = (token, expiration) => {
		setToken(token);
		localStorage.setItem('mlannex-token', token);
		localStorage.setItem('mlannex-expiration', expiration);
		// localStorage.setItem(
		// 	'userData',
		// 	JSON.stringify({token: token, expiration: expiration})
		// );

		const remainingTime = calculateRemainingTime(expiration);
		const notificationTime = remainingTime - priorNotificationTime;
// console.log('LOGIN HANDLER: REMAINING TIME: ' + remainingTime);
// console.log('LOGIN HANDLER: NOTIFICATION TIME: ' + notificationTime);

		logoutTimer = setTimeout(logoutHandler, remainingTime);
		notificationTimer = setTimeout(notificationHandler, notificationTime);
	}

	const browserHandler = (trust) => {
		setTrustedBrowser(trust);
	}

	const expirationHandler = () => {
		const expiration = new Date(new Date().getTime() + logoutTime);
		localStorage.setItem('mlannex-expiration', expiration);

		const remainingTime = calculateRemainingTime(expiration);
		const notificationTime = remainingTime - priorNotificationTime;
// console.log('EXPERATION HANDLER: REMAINING TIME: ' + remainingTime);
// console.log('EXPERATION HANDLER: NOTIFICATION TIME: ' + notificationTime);

		clearTimeout(logoutTimer);
		clearTimeout(notificationTimer);
		logoutTimer = setTimeout(logoutHandler, remainingTime);
		notificationTimer = setTimeout(notificationHandler, notificationTime);

		if (timeoutNotification) {
// console.log('auth: notificationHandler: settimeoutNotification: false');
			// Clear the timeout warning
			settimeoutNotification(false);
		}
	}

	useEffect(() => {
		if (tokenData) {
// console.log('USE EFFECT: DURATION: ' + tokenData.duration);
// console.log('USE EFFECT: NOTIFICATION: ' + tokenData.notification);

			clearTimeout(logoutTimer);
			clearTimeout(notificationTimer);
			logoutTimer = setTimeout(logoutHandler, tokenData.duration);
			if (tokenData.notification <= 0) {
				notificationHandler();
			} else {
				notificationTimer = setTimeout(notificationHandler, tokenData.notification);
			}
		} else {
			clearTimeout(logoutTimer);
			clearTimeout(notificationTimer);
		}
	}, [tokenData, logoutHandler, notificationHandler]);

	const contextValue = {
		token,
		isLoggedIn: userIsLoggedIn,
		trustedBrowser,
		timeoutNotification,
		login: loginHandler,
		logout: logoutHandler,
		trustBrowser: browserHandler,
		updateExpiration: expirationHandler
	}

	return (
		<AuthContext.Provider value={contextValue}>
			{props.children}
		</AuthContext.Provider>
	)
};

export default AuthContext;